<div
  #svgContainer
  class="shared-loading-g-svg-container"
  [ngStyle]="{
    '--g-container-padding': animation.containerPadding,
  }">

  <svg viewBox="0 0 800 800" preserveAspectRatio="xMidYMid meet" width="100%" height="100%">

    <g>

      @if (animation.topSection.animation === 'dash-runner-neon' || animation.topSection.animation === 'animation-draw-once-neon-flash') {
        <ng-container
          >
          <path
            id="topSectionBase"
            d="M773,266.46a387.59,387.59,0,0,1,15.09,57H625c-14,0-26.32-8.28-32.58-21l-.18-.19a218.43,218.43,0,0,0-11.22-20.24C542.6,221.19,474.88,180.71,397.59,180.71a216.74,216.74,0,0,0-157.7,365.46C127.82,488.94,51.27,372.27,51.27,237.94A353.91,353.91,0,0,1,53.48,198C122.48,79.5,250.56,0,397.59,0,544.44,0,672.7,79.5,741.52,198A391.76,391.76,0,0,1,773,266.46Z"
          [ngClass]="{
           'top-animation': animation.topSection.animation === 'animation-draw-once-neon-flash',
           'draw-top-once-neon-flash-base': animation.topSection.animation === 'animation-draw-once-neon-flash',
          }"/>
          </ng-container>
        }

        <path
          class="animation-path top-animation"
          id="topSection"
          d="M773,266.46a387.59,387.59,0,0,1,15.09,57H625c-14,0-26.32-8.28-32.58-21l-.18-.19a218.43,218.43,0,0,0-11.22-20.24C542.6,221.19,474.88,180.71,397.59,180.71a216.74,216.74,0,0,0-157.7,365.46C127.82,488.94,51.27,372.27,51.27,237.94A353.91,353.91,0,0,1,53.48,198C122.48,79.5,250.56,0,397.59,0,544.44,0,672.7,79.5,741.52,198A391.76,391.76,0,0,1,773,266.46Z"
        [ngClass]="{
          'dash-runner-top': animation.topSection.animation === 'dash-runner',
          'dash-runner-neon-top': animation.topSection.animation === 'dash-runner-neon',
          'dash-runner-reverse-top': animation.topSection.animation === 'dash-runner-reverse',
          'draw-top-once': animation.topSection.animation === 'animation-draw-once',
          'draw-top-once-neon': animation.topSection.animation === 'animation-draw-once-neon',
          'draw-top-once-neon-flash': animation.topSection.animation === 'animation-draw-once-neon-flash',
          'draw-reverse-top-once': animation.topSection.animation === 'animation-draw-reverse-once'
        }"
        [ngStyle]="{
          '--g-animation-name-top-section': animation.topSection.animation,
          '--g-animation-delay-top-section': animation.topSection.delay,
          '--g-animation-direction-top-section': animation.topSection.direction,
          '--g-animation-duration-top-section': animation.topSection.duration,
          '--g-animation-fill-mode-top-section': animation.topSection.fill,
          '--g-animation-fill-colour-top': animation.topSection.fillColour,
          '--g-animation-iteration-count-top-section': animation.topSection.iterationCount,
          '--g-animation-play-state-top-section': animation.topSection.playState,
          '--g-animation-timing-function-top-section': animation.topSection.timingFunction,
          '--g-stroke-colour-top-section': animation.topSection.strokeColour,
          '--g-stroke-dasharray-top-section': animation.topSection.strokeDashArray,
          '--g-stroke-dashoffset-top-section': animation.topSection.strokeDashOffset,
          '--g-stroke-dashoffset-end-top-section': animation.topSection.strokeDashOffsetEnd,
          '--g-stroke-width-top-section': animation.topSection.strokeWidth,
        }"/>

          @if (animation.bottomSection.animation === 'dash-runner-neon' || animation.bottomSection.animation === 'animation-draw-once-neon-flash') {
            <ng-container
              >
              <path
                id="bottomSectionBase"
                d="M795.07,495.93V790.54H614.36v-59.8C541.86,778,452.8,802.32,357.84,793.12,176.22,775.45,27.35,632.29,3.61,451.4-5,386.25,2.13,323.32,22.19,266.46c14.54,194.5,177,347.79,375.4,347.79A215.51,215.51,0,0,0,517.2,578.18H397.59V397.48H696.44A98.6,98.6,0,0,1,795.07,495.93Z"
          [ngClass]="{
           'bottom-animation': animation.topSection.animation === 'animation-draw-once-neon-flash',
           'draw-bottom-once-neon-flash-base': animation.topSection.animation === 'animation-draw-once-neon-flash',
          }"/>
              </ng-container>
            }

            <path
              class="animation-path bottom-animation"
              id="bottomSection"
              d="M795.07,495.93V790.54H614.36v-59.8C541.86,778,452.8,802.32,357.84,793.12,176.22,775.45,27.35,632.29,3.61,451.4-5,386.25,2.13,323.32,22.19,266.46c14.54,194.5,177,347.79,375.4,347.79A215.51,215.51,0,0,0,517.2,578.18H397.59V397.48H696.44A98.6,98.6,0,0,1,795.07,495.93Z"
        [ngClass]="{
          'dash-runner-bottom': animation.bottomSection.animation === 'dash-runner',
          'dash-runner-neon-bottom': animation.bottomSection.animation === 'dash-runner-neon',
          'dash-runner-reverse-bottom': animation.bottomSection.animation === 'dash-runner-reverse',
          'draw-bottom-once': animation.bottomSection.animation === 'animation-draw-once',
          'draw-bottom-once-neon': animation.topSection.animation === 'animation-draw-once-neon',
          'draw-bottom-once-neon-flash': animation.topSection.animation === 'animation-draw-once-neon-flash',
          'draw-reverse-bottom-once': animation.topSection.animation === 'animation-draw-reverse-once'
        }"
        [ngStyle]="{
          '--g-animation-name-bottom-section': animation.bottomSection.animation,
          '--g-animation-delay-bottom-section': animation.bottomSection.delay,
          '--g-animation-direction-bottom-section': animation.bottomSection.direction,
          '--g-animation-duration-bottom-section': animation.bottomSection.duration,
          '--g-animation-fill-mode-bottom-section': animation.bottomSection.fill,
          '--g-animation-fill-colour-bottom': animation.bottomSection.fillColour,
          '--g-animation-iteration-count-bottom-section': animation.bottomSection.iterationCount,
          '--g-animation-play-state-bottom-section': animation.bottomSection.playState,
          '--g-animation-timing-function-bottom-section': animation.bottomSection.timingFunction,
          '--g-stroke-colour-bottom-section': animation.bottomSection.strokeColour,
          '--g-stroke-dasharray-bottom-section': animation.bottomSection.strokeDashArray,
          '--g-stroke-dashoffset-bottom-section': animation.bottomSection.strokeDashOffset,
          '--g-stroke-dashoffset-end-bottom-section': animation.bottomSection.strokeDashOffsetEnd,
          '--g-stroke-width-bottom-section': animation.bottomSection.strokeWidth,
        }"/>

            </g>

          </svg>

        </div>
